module.exports = __webpack_public_path__ + "static/media/jade.c5b6bb5f.png";